import { createGlobalState } from '@vueuse/core';
// import { defineStore } from 'pinia';
import { ref, computed, defineAsyncComponent } from 'vue';

const loadComponent = (name, payload) => ({
    component: defineAsyncComponent(() => import(`@vuejs/popup/${name}.vue`)),
    payload,
});

export const useSharedPopup = createGlobalState(() => {
    const componentsStack = ref([]);

    const getCurrent = computed(() => componentsStack.value.at(-1));
    const getAmount = computed(() => componentsStack.value.length);

    /**
     * Shows the offcanvas with the specified component name.
     *
     * @param {string} componentName - The name of the component to display in the offcanvas.
     * @returns {Promise<void>} A promise that resolves when the offcanvas is shown.
     */
    const show = async (componentName, payload) => {
        window.bootstrap.popup.show();

        console.log('show', componentName);

        // @ts-ignore - this is a dynamic import
        componentsStack.value.push(loadComponent(componentName, payload));
    };

    const replace = (componentName, payload) => {
        componentsStack.value.pop();
        // @ts-ignore - this is a dynamic import
        componentsStack.value.push(loadComponent(componentName, payload));
    };

    /**
     * Hides the currently opened offcanvas
     *
     * @returns {Promise<void>} A promise that resolves when the offcanvas is shown.
     */
    const hide = async () => {
        componentsStack.value.pop();

        if (componentsStack.value.length === 0) {
            window.bootstrap.popup.hide();
        }
    };

    const hideAll = () => {
        componentsStack.value = [];
        window.bootstrap.popup.hide();
    };

    return {
        componentsStack,
        getCurrent,
        getAmount,
        show,
        replace,
        hide,
        hideAll,
    };
});
